export let helpers = {
	isHeroShown: false,
	lastDirection: 'down',

	loadImages(images) {
		return new Promise((resolve) => {
			let resources = {};
			let counter = 0;

			$.each(images, (i, element) => {
				let image = new Image();

				image.src = '';
				image.src = element;
				image.onload = () => {
					counter += 1;
					resources[i] = {
						src: element,
						img: image,
					};
				};
			});

			let loadingWatcher = setInterval(() => {
				if (counter === Object.keys(images).length) {
					resolve(resources);
					clearInterval(loadingWatcher);
				}
			}, 50);
		});
	},

	getContent(url, tag) {
		return new Promise((resolve) => {
			if (tag === 'news') {
				resolve(helpers.newsCont);
			}
		});
	},

	getScrollDirection() {
		let st = $(window).scrollTop();
		let curDir;

		if (st > this.lastDirection) {
			curDir = 'down';
		} else {
			curDir = 'up';
		}
		this.lastDirection = st;

		return curDir;
	},

	checkMobile() {
		if (/Mobi/.test(navigator.userAgent)) {
			$('html').addClass('is-device-mobile');
		} else {
			$('html').addClass('is-device-desktop');
		}
	},

	checkIE() {
		let ua = window.navigator.userAgent;
		let msie = ua.indexOf('MSIE ');

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
			$('html').addClass('is-browser-ie');
		}
	},

	isElementPartiallyInViewport(el, yOffset = $(el).height() / 2) {
		let rect = el.getBoundingClientRect();
		let windowHeight = window.innerHeight || document.documentElement.clientHeight;
		let windowWidth = window.innerWidth || document.documentElement.clientWidth;

		let vertInView = rect.top <= windowHeight - yOffset && rect.top + rect.height >= 0;
		let horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

		return vertInView && horInView;
	},

	isElementInViewport(el) {
		let rect = el.getBoundingClientRect();
		let windowHeight = window.innerHeight || document.documentElement.clientHeight;
		let windowWidth = window.innerWidth || document.documentElement.clientWidth;

		return (
			rect.left >= 0
			&& rect.top >= 0
			&& rect.left + rect.width <= windowWidth
			&& rect.top + rect.height <= windowHeight
		);
	},

	getQueryParam(key, query = location.search) {
		let result = '';
		let params = query.replace(/^\?/, '').split('&');

		for (let i = 0; i < params.length; i++) {
			let param = params[i].split('=');

			if (param[0] === key) {
				result = param[1];
			}
		}

		return result;
	},

	getScrollBarWidth() {
		let $outer = $('<div>').css({
			visibility: 'hidden',
			width: 100,
			overflow: 'scroll',
		}).appendTo('body');
		let widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		let scrollBarWidth = 100 - widthWithScroll;

		$outer.remove();

		return scrollBarWidth;
	},

	setSliderWidth($container) {
		if (!$container.length) {
			return;
		}

		let windowWidth = $(window).width();
		let offset = $container.offset().left;

		$container.css('width', windowWidth - offset);
	},

	formatNumber(number) {
		let result;

		if (number <= 9) {
			result = `0${number}`;
		} else {
			result = `${number}`;
		}

		return result;
	},

	onlyNumbers(e) {
		// Allow: backspace, delete, tab, escape, enter and .
		if ($.inArray(e.keyCode, [32, 43, 46, 8, 9, 27, 13, 107, 110, 187, 189, 190]) !== -1 ||
		// Allow: Ctrl/cmd+A
		e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) ||
		// Allow: Ctrl/cmd+C
		e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true) ||
		// Allow: Ctrl/cmd+X
		e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true) ||
		// Allow: home, end, left, right
		e.keyCode >= 35 && e.keyCode <= 39) {
			// let it happen, don't do anything
			return;
		}

		// Ensure that it is a number and stop the keypress
		if (((e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
			e.preventDefault();
		}
	},

	setHeadingdotPosition() {
		let bgLine = $('.bg__line')[0];
		let $headingText = $('.heading__text');

		$headingText.each((i, elem) => {
			let $dot = $(elem).find('.heading__dot');
			let offset = $(elem).offset().left - $(bgLine).offset().left + $dot.outerWidth() / 2;

			$dot.css({
				left: -offset,
			});
		});
	},

	getVideoThumbnail(src) {
		return new Promise((resolve) => {
			let dataUrl;
			let video = document.createElement('VIDEO');
			let canvas = document.createElement('CANVAS');

			video.src = src;
			video.crossOrigin = 'Anonymous';

			video.classList.add('helper-video');
			canvas.classList.add('helper-canvas');

			$('html').append(video);
			$('html').append(canvas);

			let ctx = canvas.getContext('2d');

			video.addEventListener('loadeddata', () => {
				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;

				ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
				dataUrl = canvas.toDataURL();

				$(video).remove();
				$(canvas).remove();

				resolve(dataUrl);
			});

			video.addEventListener('error', () => {
				$(video).remove();
				$(canvas).remove();
			});
		});
	},

	getYoutubeThumbPath(url) {
		if (!url) {
			return;
		}

		let video;
		let results = url.match('[\\?&]v=([^&#]*)');

		if (results === null) {
			video = url.split('embed/')[1].split('&')[0];
		} else {
			video = results[1];
		}

		return `http://img.youtube.com/vi/${video}/0.jpg`; // eslint-disable-line
	},

	getVimeoThumbnail(id) { // eslint-disable-line
		if (id) {
			return new Promise((resolve) => {
				$.ajax({
					type: 'GET',
					url: `http://vimeo.com/api/v2/video/${id}.json`,
					jsonp: 'callback',
					dataType: 'jsonp',
					success(data) {
						let thumbnailSrc = data[0].thumbnail_large;

						resolve(thumbnailSrc);
					},
				});
			});
		}
	},

	sizeRedirect() {
		if ($(window).width() > 768) {
			if (location.href.indexOf('mobile') !== -1) {
				location.replace(`${location.origin}${location.pathname.split('/mobile')[1]}`);
			}
		} else if (location.href.indexOf('mobile') === -1) {
			location.replace(`${location.origin}/mobile${location.pathname}`);
		}
	},

	swipeDetect(el, callback) {
		var touchsurface = el,
		swipedir,
		startX,
		startY,
		distX,
		distY,
		threshold = 150, //required min distance traveled to be considered swipe
		restraint = 100, // maximum distance allowed at the same time in perpendicular direction
		allowedTime = 300, // maximum time allowed to travel that distance
		elapsedTime,
		startTime,
		handleswipe = callback || function(swipedir){}

		touchsurface.addEventListener('touchstart', function(e){
			var touchobj = e.changedTouches[0];
			distX = 0;
			distY = 0;
			swipedir = 'none';
			startX = touchobj.pageX;
			startY = touchobj.pageY;
			startTime = new Date().getTime(); // record time when finger first makes contact with surface
			// e.preventDefault()
		}, false);

		touchsurface.addEventListener('touchmove', function(e){
			if (startY === e.pageY) {
				e.preventDefault() // prevent scrolling when inside DIV
			}
		}, false);

		touchsurface.addEventListener('touchend', function(e){
			var touchobj = e.changedTouches[0]
			distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
			distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
			elapsedTime = new Date().getTime() - startTime; // get time elapsed

			if (elapsedTime <= allowedTime){ // first condition for swipe met
				if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
					swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
				}
				else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
					swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
				}
			}

			handleswipe(swipedir)
			// e.preventDefault()
		}, false);
	},

	calc_bg_object(elem, container, elem_w, elem_h) {
		var ww = $(container).width();
		var wh = $(container).height();

		var dvw = elem_w,
		   dvh = elem_h,
		   vw = ww,
		   vh = Math.round(vw / dvw * dvh),
		   vl = 0,
		   vt = 0;

		if (vh < wh) {
		   vh = wh;
		   vw = Math.round(vh / dvh * dvw);
		}

		vl = Math.round((ww - vw) / 2);
		vt = Math.round((wh - vh) / 3);

		$(elem).css({top: vt, left: vl, width: vw, height: vh});
	 },
};
